import { amplitudeTracker } from '../amplitude-tracker';
import config from '../../../config';

const DEFAULT_ERROR = {
    'message': 'Server unavailable. Please check your connection and try again.'
};

class ApiClient {
    constructor({ prefix = 'v1/' } = {}) {
        this.prefix = prefix;
    }

    async get({ url, params }) {
        return this.request({
            url,
            params,
            method: 'GET'
        });
    }

    async post({ url, body = {} }) {
        return this.request({
            url,
            method: 'POST',
            body
        });
    }

    getHeaders(method) {
        const headers = method !== 'GET' ? { 'Content-Type': 'application/json' } : {};
        const transactionId = window.crypto?.randomUUID?.();
        const deviceId = amplitudeTracker.getDeviceId();

        if (transactionId) {
            headers['X-Transaction-Id'] = transactionId;
        }

        if (deviceId) {
            headers['X-Device-Id'] = deviceId;
        }

        return headers;
    }

    async getJsonFromResponse(response) { /* for 201 status code */
        try {
            const json = await response.json();

            return json;
        } catch {
            return {};
        }
    }

    async request({ url, method, params = {}, body }) {
        const query = Object.keys(params).length ? `?${new URLSearchParams(params).toString()}` : '';
        const options = {
            method,
            headers: this.getHeaders(method),
            body: body ? JSON.stringify(body) : undefined
        };
        const fullUrl = `${config.apiUrl}${this.prefix}${url}`;
        const response = await fetch(`${fullUrl}${query}`, options);

        if (response.status >= 500) throw DEFAULT_ERROR;

        if (response.status === 204 || response.status === 202) return {};

        const json = await this.getJsonFromResponse(response);

        if (response.status >= 400) {
            throw json;
        }

        return json;
    }
}

export {
    ApiClient
};
